/* Peppy theme — progressive-enhancement behaviours. No dependencies. */
(function () {
  'use strict';

  /* ---------- Mobile navigation drawer ---------- */
  function initDrawer() {
    var drawer = document.querySelector('[data-drawer]');
    if (!drawer) return;
    var openers = document.querySelectorAll('[data-drawer-open]');
    var closers = drawer.querySelectorAll('[data-drawer-close]');

    function open() {
      drawer.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      var first = drawer.querySelector('a, button');
      if (first) first.focus();
    }
    function close() {
      drawer.classList.remove('is-open');
      document.body.style.overflow = '';
    }
    openers.forEach(function (b) { b.addEventListener('click', open); });
    closers.forEach(function (b) { b.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    });
  }

  /* ---------- Slideshow ---------- */
  function initSlideshows() {
    document.querySelectorAll('[data-slideshow]').forEach(function (root) {
      var track = root.querySelector('[data-slideshow-track]');
      var slides = root.querySelectorAll('.slideshow__slide');
      var dots = root.querySelectorAll('[data-slideshow-dot]');
      if (slides.length < 2) return;

      var index = 0;
      var timer = null;
      var interval = parseInt(root.dataset.autoplay, 10) || 0;
      var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      function go(i) {
        index = (i + slides.length) % slides.length;
        track.style.transform = 'translateX(-' + index * 100 + '%)';
        dots.forEach(function (d, di) {
          d.setAttribute('aria-current', di === index ? 'true' : 'false');
        });
        slides.forEach(function (s, si) {
          s.setAttribute('aria-hidden', si === index ? 'false' : 'true');
        });
      }
      function play() {
        if (!interval || reduced) return;
        stop();
        timer = setInterval(function () { go(index + 1); }, interval);
      }
      function stop() { if (timer) clearInterval(timer); }

      root.querySelectorAll('[data-slideshow-next]').forEach(function (b) {
        b.addEventListener('click', function () { go(index + 1); play(); });
      });
      root.querySelectorAll('[data-slideshow-prev]').forEach(function (b) {
        b.addEventListener('click', function () { go(index - 1); play(); });
      });
      dots.forEach(function (d, di) {
        d.addEventListener('click', function () { go(di); play(); });
      });
      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', play);

      // touch swipe
      var startX = null;
      root.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
      root.addEventListener('touchend', function (e) {
        if (startX === null) return;
        var dx = e.changedTouches[0].clientX - startX;
        if (Math.abs(dx) > 45) go(index + (dx < 0 ? 1 : -1));
        startX = null;
      });

      go(0);
      play();
    });
  }

  /* ---------- Tabs ---------- */
  function initTabs() {
    document.querySelectorAll('[data-tabs]').forEach(function (root) {
      var tabs = root.querySelectorAll('[role="tab"]');
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          tabs.forEach(function (t) {
            var panel = root.querySelector('#' + t.getAttribute('aria-controls'));
            var active = t === tab;
            t.setAttribute('aria-selected', active ? 'true' : 'false');
            if (panel) panel.hidden = !active;
          });
        });
      });
    });
  }

  /* ---------- Product gallery ---------- */
  function initGalleries() {
    document.querySelectorAll('[data-gallery]').forEach(function (root) {
      var main = root.querySelector('[data-gallery-main]');
      var thumbs = root.querySelectorAll('[data-gallery-thumb]');
      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          if (!main) return;
          main.src = thumb.dataset.src || thumb.querySelector('img').src;
          if (thumb.dataset.srcset) main.srcset = thumb.dataset.srcset;
          main.alt = thumb.querySelector('img').alt || '';
          thumbs.forEach(function (t) {
            t.setAttribute('aria-current', t === thumb ? 'true' : 'false');
          });
        });
      });
    });
  }

  /* ---------- Variant selection ---------- */
  function initVariants() {
    document.querySelectorAll('[data-variant-picker]').forEach(function (root) {
      var data = root.querySelector('[data-variant-json]');
      if (!data) return;
      var variants;
      try { variants = JSON.parse(data.textContent); } catch (e) { return; }

      var idInput = root.querySelector('[data-variant-id]');
      var priceEl = root.querySelector('[data-variant-price]');
      var addBtn = root.querySelector('[data-add-button]');
      var mainImg = document.querySelector('[data-gallery-main]');

      root.addEventListener('change', function () {
        var chosen = Array.prototype.map.call(
          root.querySelectorAll('[data-option-index]'),
          function (group) {
            var checked = group.querySelector('input:checked');
            return checked ? checked.value : (group.value || null);
          }
        );

        var match = variants.find(function (v) {
          return chosen.every(function (val, i) {
            return val === null || v.options[i] === val;
          });
        });

        if (!match) return;
        if (idInput) idInput.value = match.id;
        if (priceEl && match.price_html) priceEl.innerHTML = match.price_html;
        if (mainImg && match.featured_image) mainImg.src = match.featured_image;
        if (addBtn) {
          addBtn.disabled = !match.available;
          addBtn.textContent = match.available
            ? addBtn.dataset.labelAvailable
            : addBtn.dataset.labelSoldOut;
        }
        if (window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', match.id);
          window.history.replaceState({}, '', url.toString());
        }
      });
    });
  }

  /* ---------- Quantity steppers ---------- */
  function initQuantity() {
    document.querySelectorAll('[data-qty]').forEach(function (root) {
      var input = root.querySelector('input');
      root.querySelectorAll('[data-qty-change]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var next = parseInt(input.value, 10) + parseInt(btn.dataset.qtyChange, 10);
          input.value = Math.max(parseInt(input.min || 1, 10), next);
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });
  }

  /* ---------- Age gate ---------- */
  function initAgeGate() {
    var gate = document.querySelector('[data-age-gate]');
    if (!gate) return;
    var key = 'peppy:age-confirmed';
    var stored = null;
    try { stored = localStorage.getItem(key); } catch (e) { stored = null; }

    if (stored === 'yes' || window.Shopify && window.Shopify.designMode && gate.dataset.previewHidden === 'true') {
      gate.hidden = true;
      return;
    }
    gate.hidden = false;
    document.body.style.overflow = 'hidden';

    gate.querySelector('[data-age-yes]').addEventListener('click', function () {
      try { localStorage.setItem(key, 'yes'); } catch (e) {}
      gate.hidden = true;
      document.body.style.overflow = '';
    });
    var no = gate.querySelector('[data-age-no]');
    if (no) {
      no.addEventListener('click', function () {
        gate.querySelector('[data-age-body]').innerHTML =
          '<p>You need to be 18 or older to shop here. Come back when you are.</p>';
      });
    }
  }

  function init() {
    initDrawer();
    initSlideshows();
    initTabs();
    initGalleries();
    initVariants();
    initQuantity();
    initAgeGate();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init in the theme editor when sections are re-rendered
  document.addEventListener('shopify:section:load', init);
})();
